'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var Divtable = new Class({
	Implements: [Events, Options],
	options: {
		cls: 'w_divtable',
		zebring: true,
		zebra_order: 'even', //even or odd
		zebra_class: 'x',
		sortable: false,
		animate_on_sort: true,
		no_data_char: '-',
		first_sort: 'desc'
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);

		this._element = _element || document.getElement('.w_divtable');

		if (this._element) this.build();
	},

	build: function build() {
		var opts = this.opts = this.options;
		this._thead = this._element.getElement('.thead');
		this._tbody = this._element.getElement('.tbody');
		this._trs = this._tbody.getElements('.tr');

		this.first_sort = this.options.first_sort;
		this.second_sort = this.options.first_sort == 'desc' ? 'asc' : 'desc';

		if (this._trs.length > 500) {
			opts.animate_on_sort = false;
		}

		if (opts.sortable) {
			this._element.addClass('sortable');
			this.trs = []; //array of objects for sorting

			this._trs.each(function (_el) {
				this.trs.push({
					element: _el
				});
			}.bind(this));

			if (opts.sortable && this._trs.length > 1) {
				this.get_sorting_togglers();
			}
		}

		if (opts.zebring == true) {
			this.zebring();
		}

		if (Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android') {
			this._element.addClass('_touch');
		}

		this.linking();

		this.add_tr_events();
	},

	add_new_rows: function add_new_rows(rows) {
		var even_or_odd = this._trs.length % 2;

		if (rows && rows.length > 0) {
			rows.each(function (_el) {
				if (!this._trs) {
					this._trs = [];
				}

				this._trs.push(_el);

				if (this.trs) {
					this.trs.push({
						element: _el
					});
				}
			}.bind(this));

			if (this.opts.zebring == true) {
				this.zebring(rows, even_or_odd);
			}

			this.linking(rows);
			this.sorted = false;
		}
	},

	zebring: function zebring(rows, even_or_odd) {
		var opts = this.options,
		    order = 0;

		if (!even_or_odd || even_or_odd == 0) {
			order = opts.zebra_order == 'odd' ? 1 : 0;
		} else {
			order = opts.zebra_order == 'odd' ? 0 : 1;
		}

		var _rows = rows && rows.length > 0 ? rows : this._trs;

		_rows.each(function (_el, i) {
			i = i + order;

			if (i % 2 == 0) {
				_el.removeClass(opts.zebra_class);
			} else {
				_el.addClass(opts.zebra_class);
			}
		});
	},

	linking: function linking(_trs) {
		var _rows = _trs || this._trs;

		_rows.each(function (_el) {
			var href = _el.getAttribute('data-href');

			if (!href || href == '') return;

			var _photo = _el.getElement('.photo');

			if (!_photo) {
				_el.addClass('link');
				_el.addEvent('click', function () {
					window.location = href;
				});
				return;
			}

			_photo = _photo.getElement('.lst_photo') || _photo;

			_photo.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (e.shift || e.control || e.meta || e.alt) {
					var _temp_a = new Element('a', {
						target: "_blank",
						href: href,
						styles: {
							display: "none"
						}
					}).inject(_photo.getParent());

					var custom_event = document.createEvent('MouseEvents');

					custom_event.initMouseEvent('click', true, true, window);
					_temp_a.dispatchEvent(custom_event);
					_temp_a.destroy();
				} else {
					window.location = href;
				}
			});
		});
	},

	get_sorting_togglers: function get_sorting_togglers() {
		if (!this._thead) return;

		this._sorters = this._thead.getElements('.th[data-sort]');

		if (this._thead.hasClass('dropdown')) {
			this.create_dropdown();
		}

		this._sorters.each(function (_el) {
			if (!_el.getElement('.sort_span')) {
				_el.set('html', _el.get('html') + '<span class="sort_span">&nbsp;</span>');
			}

			var data_sort = _el.getAttribute('data-sort');
			data_sort = data_sort.toLowerCase();

			if (data_sort != '') {
				if (!_el.hasClass('.sort')) {
					_el.addClass('sort unsorted');
				}

				_el.addEvent('click', function (e) {
					if (e && e.stop) {
						e.stop();
					}

					_el.removeClass('unsorted');

					this.order = this.first_sort;

					if (_el.hasClass(this.first_sort)) {
						_el.removeClass(this.first_sort);
						_el.addClass(this.second_sort);
						this.order = this.second_sort;
					} else if (_el.hasClass(this.second_sort)) {
						_el.removeClass(this.second_sort);
						_el.addClass(this.first_sort);
					} else {
						_el.addClass(this.first_sort);
						this.sorted = false;
					}

					this.sort(data_sort);

					if (this._prev_sorter && this._prev_sorter != _el) {
						this._prev_sorter.removeClass(this.first_sort);
						this._prev_sorter.removeClass(this.second_sort);
						this._prev_sorter.addClass('unsorted');
					}

					this._prev_sorter = _el;
					this.fireEvent('sorting', [_el]);
				}.bind(this));
			}
		}.bind(this));
	},

	before_sort: function before_sort(sort) {
		this.compare_strings = false;

		this.trs.each(function (_el) {
			var data = 'data-' + sort;
			var value = _el.element.getAttribute(data);

			if (_el.element.getStyle('display') == 'none') {
				this.trs_nottosort.push(_el);
			} else {
				if (!value || value == '' || value == this.opts.no_data_char) {
					this.trs_nottosort.push(_el);
				} else {
					if (value.toFloat()) {
						_el.value = value.toFloat();
					} else {
						_el.value = value;
						this.compare_strings = true;
					}

					this.trs_tosort.push(_el);
				}
			}
		}.bind(this));
	},

	sort: function sort(_sort) {
		var opts = this.options;

		if (!this.sorted) {
			//do not sort if array has been just sorted with this sorter
			this.trs_length = this.trs.length;

			this.trs_tosort = [];
			this.trs_nottosort = [];
			this.before_sort(_sort);

			this.quick_sort(0, this.trs_tosort.length - 1, _sort);

			this.sorted = true;
		}

		var temp_array;
		if (this.order == 'asc') {
			temp_array = Array.clone(this.trs_tosort);
			this.trs = temp_array.append(this.trs_nottosort);
		} else {
			temp_array = Array.clone(this.trs_nottosort);
			this.trs = temp_array.append(this.trs_tosort);
		}

		this._tbody.empty();

		if (opts.animate_on_sort) {
			if (opts.zebring) {
				this.trs.each(function (_el, i) {
					_el.element.setStyles({
						'visibility': 'hidden',
						'opacity': 0
					});

					this.insert_element_zebring_animate(_el.element, i);
				}.bind(this));
			} else {
				this.trs.each(function (_el, i) {
					_el.element.setStyles({
						'visibility': 'hidden',
						'opacity': 0
					});

					this.insert_element_simple_animate(_el.element, i);
				}.bind(this));
			}
		} else {
			if (opts.zebring) {
				this.trs.each(function (_el, i) {
					this.insert_element_zebring(_el.element, i);
				}.bind(this));
			} else {
				this.trs.each(function (_el) {
					this.insert_element_simple(_el.element);
				}.bind(this));
			}
		}
	},

	insert_element_zebring: function insert_element_zebring(_el, i) {
		if (this.opts.zebra_order == 'odd') {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			} else {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			}
		} else {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			} else {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
			}
		}
	},

	insert_element_zebring_animate: function insert_element_zebring_animate(_el, i) {
		if (this.opts.zebra_order == 'odd') {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			} else {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			}
		} else {
			if (this.order == 'asc') {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody);
			} else if (this.order == 'desc' && this.trs.length % 2 == 0) {
				i % 2 == 0 ? _el.addClass(this.opts.zebra_class) : _el.removeClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			} else {
				i % 2 == 0 ? _el.removeClass(this.opts.zebra_class) : _el.addClass(this.opts.zebra_class);
				_el.inject(this._tbody, 'top');
				i = this.trs_length - 1 - i;
			}
		}

		(function () {
			_el.fade('in');
		}).delay(i * 50);
	},

	insert_element_simple: function insert_element_simple(_el) {
		if (this.order == 'asc') {
			_el.inject(this._tbody);
		} else {
			_el.inject(this._tbody, 'top');
		}
	},

	insert_element_simple_animate: function insert_element_simple_animate(_el, i) {
		if (this.order == 'asc') {
			_el.inject(this._tbody);
		} else {
			_el.inject(this._tbody, 'top');
		}

		if (this.order == 'desc') {
			i = this.trs_length - 1 - i;
		}

		(function () {
			_el.fade('in');
		}).delay(i * 50);
	},

	quick_sort: function quick_sort(first, last, sort) {
		//recursive function
		var left = first + 1,
		    right = last,
		    center,
		    temp;

		if (first < last) {
			center = this.trs_tosort[first];

			do {
				if (this.compare_strings) {
					while (left <= right && this.trs_tosort[left].value + '' <= center.value + '') {
						left++;
					}

					while (left <= right && this.trs_tosort[right].value + '' > center.value + '') {
						right--;
					}
				} else {
					while (left <= right && this.trs_tosort[left].value <= center.value) {
						left++;
					}

					while (left <= right && this.trs_tosort[right].value > center.value) {
						right--;
					}
				}

				if (left < right) {
					temp = this.trs_tosort[right];
					this.trs_tosort[right] = this.trs_tosort[left];
					this.trs_tosort[left] = temp;
					left++;
					right--;
				}
			} while (left <= right);

			temp = this.trs_tosort[right];
			this.trs_tosort[right] = this.trs_tosort[first];
			this.trs_tosort[first] = temp;

			this.quick_sort(first, right - 1, sort);
			this.quick_sort(right + 1, last, sort);
		}
	},

	create_dropdown: function create_dropdown() {
		this._thead.clone().inject(this._thead, 'after');

		this._sort_display = new Element('.sort_display');
		this._sort_display.inject(this._thead, 'top');

		this._thead.removeClass('thead').addClass('styled_select fake');

		new Element('.clearfix').inject(this._element, 'before').adopt(this._thead);

		this._sorters.each(function (_el) {
			var value = _el.getAttribute('data-value');

			if (value && value != '') {
				_el.set('html', value);
			}

			_el.setProperty('class', 'dropdown_item');

			var data_sort = _el.getAttribute('data-sort');

			if (!data_sort || data_sort == '') {
				_el.dispose();
			}
		});

		this._sort_display.set('html', this._sorters[0].get('html'));

		this._list = this._thead.getElement('.tr').removeClass('tr').addClass('dropdown_list');

		this._list.setStyle('visibility', 'hidden');
		this.dd_height = this._list.getSize().y;
		this._list.setStyle('height', 0);

		this.dd_fx = new Fx.Morph(this._list, { duration: 100, link: 'cancel' });

		this._list.setStyle('visibility', 'visible');

		this._list.setStyle('bottom', this._list.getCoordinates().y * -1);

		this.add_dropdown_behavior();
	},

	add_dropdown_behavior: function add_dropdown_behavior() {
		this._sort_display.addEvents({
			'click': this.toggle_dropdown.bind(this)
		});

		this._sorters.each(function (_el) {
			_el.addEvent('click', function () {
				this.toggle_dropdown();
				this._sort_display.set('html', _el.get('html'));
			}.bind(this));
		}.bind(this));

		$(document.body).addEvent('click:relay(div)', function (e, _element) {
			if (this._sort_display !== _element) {
				this.toggle_dropdown(0);
			}
		}.bind(this));
	},

	toggle_dropdown: function toggle_dropdown(height) {
		if (height == 0 || this._list.getSize().y > 0) {
			this.dd_fx.start({ 'height': 0 });
		} else {
			this.dd_fx.start({ 'height': this.dd_height });
		}
	},

	reinitialize: function reinitialize() {
		if (this._sorters) {
			this._sorters.each(function (_el) {
				_el.removeEvents();
			});

			this._prev_sorter = this._thead.getElement('.asc') || this._thead.getElement('.desc');
		}

		this.initialize();
	},

	add_tr_events: function add_tr_events() {
		var self = this;
		var _current_tr;
		var _current_el;

		if (Core.is_touch_supported()) {
			this._trs.each(function (_el) {
				_el.addEvents({
					'click': function click() {
						_el.toggleClass('_active');

						if (_current_el && _current_el !== _el) {
							_current_el.removeClass('_active');
						}

						_current_el = _el;
					}
				});

				$(document.body).addEvents({
					'touchstart:relay("*")': function touchstartRelay(e, _el) {
						if (!_el || _el != self._element && !_el.getParent('.w_divtable')) {
							if (typeof _current_el !== 'undefined' && _current_el) {
								_current_el.removeClass('_active');
							}
						}
					}
				});
			});
		} else {
			this._trs.each(function (_el) {
				_el.addEvents({
					'click': function click(e) {
						if (_el.get('data-href')) {
							//stop when user clicked an anchor element
							if (e && e.target && (e.target.get('href') || e.target.getParent().get('href'))) return;

							window.location = _el.get('data-href');
						}
					},
					'mouseover': function mouseover() {
						if (_current_tr && _current_tr !== _el) {
							_current_tr.removeClass('_active');
						}

						_el.addClass('_active');

						_current_tr = _el;
					},

					'mouseleave': function mouseleave() {
						_el.removeClass('_active');
					}
				});
			});
		}
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var Rater = new Class({
	Implements: [Events, Options],
	options: {
		max_size: 0, //height or width
		min_size: 0, //height or width === don't need to specify, if 'size' in this options is absolute
		max_data: 0, //max value through the elements === optional
		min_data: 0, //min value through the elements === optional
		property: 'data-height', //property of the elements where to take data
		animate: true,
		duration: 500,
		equal_speed: true, //if false, all animations will finish at the same time (duration),
		//if true, the speed for each animation is the same, so the smallest element will finish first
		transition: Fx.Transitions.linear,
		type: 'vertical', //vertical or horisontal
		size: 'absolute', //absolute or relative
		//IMPORTANT!: don't use 'relative' sizing if there is a possibility of negative values !!!!!!!!!!!!
		//if absolute, the size of each element counts from 0
		//i.e. - max_size is 100px,
		//and you have 5 elements with 'data-height's {20, 40, 60, 80, 100},
		//so, their sizes are going to be - {20, 40, 60, 80, 100}.
		//if relative, the size of each element counts from min_height
		//i.e. - max_size is 100px, min_size is 60px, and you have the same elements,
		//so, their sizes are going to be - {60, 70, 80, 90, 100}
		calculate_even_one_element: false //can be helpful when you use lazyLoader (in this case set to 'true')
	},

	initialize: function initialize(_elements, options) {
		this._elements = _elements;

		if (this._elements) {
			this.setOptions(options);
			this.build();
		}
	},

	build: function build() {
		var opts = this.options;

		if (this._elements.length == 0 || this._elements.length == 1 && !opts.calculate_even_one_element) return;

		this.max_data = opts.max_data;
		this.min_data = opts.min_data;
		this.has_negative = this.max_data < 0 || this.min_data < 0;

		if (opts.type == 'vertical') {
			this.max_size = opts.max_size == 0 ? this._elements[0].getSize().y : opts.max_size;
		} else {
			this.max_size = opts.max_size == 0 ? this._elements[0].getSize().x : opts.max_size;
		}

		if (this.max_size > 0) {
			opts.max_size = this.max_size;

			if (opts.animate == true) {
				if (opts.type == 'vertical') {
					this._elements.each(function (_el) {
						_el.setStyle('height', 0);
					});
				} else {
					this._elements.each(function (_el) {
						_el.setStyle('width', 0);
					});
				}
			}

			if (!this.max_data || this.max_data == 0) {
				this.get_values();
			}

			if (!(this.max_data == 0 && this.min_data == 0)) {
				this.calculate_size();
				this.set_size();
			}
		}
	},

	get_values: function get_values() {
		this._elements.each(function (_el) {
			var data = _el.getAttribute(this.options.property).toFloat() || 0;

			if (data > this.max_data) {
				this.max_data = data;
			}

			if (this.min_data > data || this.min_data == 0) {
				this.min_data = data;
			}

			if (data < 0) {
				this.has_negative = true;
			}
		}.bind(this));
	},

	calculate_size: function calculate_size() {
		var opts = this.options;

		if (this.options.size == 'relative') {
			var data_diff = this.max_data - this.min_data,
			    size_diff = opts.max_size.toInt() - opts.min_size.toInt();

			this._elements.each(function (_el) {
				var data = _el.getAttribute(opts.property).toFloat(),
				    this_size = opts.max_size;

				if (data_diff > 0) {
					this_size = opts.min_size + (data - this.min_data) * size_diff / data_diff;
				}

				_el.setAttribute('data-size', this_size);
			}.bind(this));

			if (this.min_data < 0) {
				console.warn("Don't use 'relative' sizing with negative values!");
			}
		} else {
			if (this.max_data > 0 && this.min_data >= 0) {
				this._elements.each(function (_el) {
					var data = _el.getAttribute(opts.property).toFloat();
					data = data > this.max_data ? this.max_data : data;

					var this_size = data * opts.max_size / this.max_data;

					_el.setAttribute('data-size', this_size);
				}.bind(this));
			} else if (this.max_data <= 0 && this.min_data < 0) {
				this._elements.each(function (_el) {
					var data = _el.getAttribute(opts.property).toFloat();
					data = data > this.max_data ? this.max_data : data;

					var this_size = data * opts.max_size / this.min_data * -1;

					_el.setAttribute('data-size', this_size);
				}.bind(this));
			} else if (this.max_data > 0 && this.min_data < 0) {
				var count_data = this.max_data + this.min_data * -1,
				    shift = this.min_data * opts.max_size / count_data * -1;

				if (opts.type == 'vertical') {
					this._elements.each(function (_el) {
						var _parent = _el.getParent();
						_parent.setStyle('height', _parent.getSize().y - shift);

						var data = _el.getAttribute(opts.property).toFloat();
						data = data > this.max_data ? this.max_data : data;

						var this_size = data * opts.max_size / count_data;

						_el.setAttribute('data-size', this_size);
					}.bind(this));
				} else {
					this._elements.each(function (_el) {
						var _parent = _el.getParent();

						_parent.setStyles({
							'margin-left': shift,
							'width': _parent.getSize().x - shift
						});

						var data = _el.getAttribute(opts.property).toFloat();
						data = data > this.max_data ? this.max_data : data;

						var this_size = data * opts.max_size / count_data;

						_el.setAttribute('data-size', this_size);
					}.bind(this));
				}
			}
		}
	},

	set_size: function set_size() {
		var _this = this;
		var opts = this.options;

		if (this.has_negative) {
			opts.animate = false;

			if (this.max_data <= 0) {
				this._elements.each(function (_el) {
					var _parent = _el.getParent();

					if (opts.type == 'vertical') {
						_parent.setStyle('height', 'auto');
					}
				}.bind(this));
			}
		}

		if (opts.animate == true) {
			this._elements.each(function (_el) {
				var size = _el.getAttribute('data-size').toFloat(),
				    this_time = opts.equal_speed == true ? size * opts.duration / opts.max_size : opts.duration,
				    animate = new Fx.Morph(_el, { duration: this_time, transition: opts.transition });

				if (opts.type == 'vertical') {
					animate.start({ 'height': [0, size] });
				} else {
					animate.start({ 'width': [0, size] });
				}

				(function () {
					animate = null;
				}).delay(this_time);
			});

			(function () {
				_this.fireEvent('animationDone');
			}).delay(opts.duration);
		} else {
			this._elements.each(function (_el) {
				var size = _el.getAttribute('data-size').toFloat(),
				    shift = 0;

				if (size < 0) {
					shift = size;
					size *= -1;
				}

				if (opts.type == 'vertical') {
					_el.setStyles({
						'height': size,
						'bottom': shift
					});
				} else {
					_el.setStyles({
						'width': size,
						'left': shift
					});
				}
			});
		}

		this.fireEvent('sizeSet');
	}
});
'use strict';

Page.Bii = new Class({
	Extends: Page,
	build: function build() {
		this.parent();

		var _diagram = document.getElement('.bld_diagram');

		if (_diagram) {
			var _bulbs = _diagram.getElements('.bulb');

			var __set_popups = function __set_popups() {
				_bulbs.each(function (_el) {
					_el.inject(_diagram, 'after');
				});
			};

			var _blds_full = _diagram.getElements('.idx_bld'),
			    rater;

			if (_blds_full) {
				var _blds = []; //to display only first 7 items

				_blds_full.each(function (_el, i) {
					i < 7 ? _blds.push(_el) : _el.getParent('.idx_item').dispose();
				});

				var max_height = _blds[0].getSize().y,
				    min_height = 150;

				new Rater(_blds, {
					'max_size': max_height,
					'min_size': min_height,
					'max_data': 0,
					'min_data': 0,
					'property': 'data-price',
					'size': 'relative',
					'animate': false,
					'type': 'vertical',
					'duration': 500,
					'equal_speed': true,
					'transition': Fx.Transitions.linear,
					'onSizeSet': function onSizeSet() {
						var _captions = _diagram.getElements('.idx_caption');

						if (_captions) {
							_captions.each(function (_el) {
								var parent_height = _el.getParent('.idx_item').getSize().y,
								    bld_height = _el.getNext('.idx_bld').getSize().y,
								    self_height = _el.getSize().y,
								    margin_top = parent_height - bld_height - self_height;

								_el.setStyle('margin-top', margin_top);
							});
						}

						__set_popups();
					}
				});
			}

			var _idx_items = _diagram.getElements('.idx_item');
			var fxs = [];

			_idx_items.each(function (_el) {
				fxs.push(new Fx.Morph(_el.getElement('.idx_bld .ava'), { duration: 200, link: 'cancel', transition: Fx.Transitions.linear.easeOut }));
			});

			_idx_items.each(function (_el, i) {
				var height = _el.getElement('.idx_bld .ava').getSize().y;
				var _bld = _el.getElement('.idx_bld');

				_bld.addEvents({
					'click': function click() {
						window.location = _el.getProperty('data-href');
					},

					'mouseenter': function mouseenter() {
						_idx_items.each(function (_e, i) {
							if (_e === _el) {
								fxs[i].start({ 'bottom': 0 });
							}
						});

						var v_pos = _bld.getSize().y + _diagram.getStyle('padding-bottom').toInt() + _bulbs[i].getElement('.pointer').getStyle('height').toInt(),
						    h_pos = _bld.getCoordinates().left - _diagram.getCoordinates().left + _bld.getSize().x / 2;

						_bulbs[i].setStyles({
							'bottom': v_pos,
							'left': h_pos
						});

						_bulbs[i].show();
					},

					'mouseleave': function mouseleave() {
						_idx_items.each(function (_e, i) {
							if (_e === _el) {
								fxs[i].start({ 'bottom': height * -1 });
							}
						});

						_bulbs[i].hide();
					}
				});
			});
		}

		var _divtable = document.getElement('.w_divtable');

		if (_divtable) {
			new Divtable(_divtable, { zebra_order: 'even', sortable: true });

			var _indicators = _divtable.getElements('.indicator');

			if (_indicators && _indicators.length > 0) {
				new Rater(_indicators, {
					'max_size': _indicators[0].getSize().x,
					'property': 'data-amount',
					'size': 'absolute',
					'animate': true,
					'type': 'horizontal',
					'duration': 1500,
					'equal_speed': false,
					'transition': Fx.Transitions.linear
				});
			}

			var _select = document.getElements('.indices_header select');

			if (_select) {
				_select.addEvent('change', function () {
					var _option = _select.getElement(':selected'),
					    option = _option.getProperty('value'),
					    _controller = _divtable.getElement('.th[data-sort=' + option + ']');

					if (_controller) {
						_controller.fireEvent('click');
					}
				});
			}
		}
	}
});
//# sourceMappingURL=bii.js.map
